import React from 'react';
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
  Box
} from '@mui/material';
import {
  Description as DocumentIcon,
  Download as DownloadIcon
} from '@mui/icons-material';

interface ComplianceDocument {
  id: string;
  name: string;
  description: string;
  lastUpdated: string;
}

const mockDocuments: ComplianceDocument[] = [
  {
    id: '1',
    name: 'Enrollment Form Template',
    description: 'Standard enrollment form with required legal disclosures',
    lastUpdated: '2023-08-01'
  },
  {
    id: '2',
    name: 'Intervention Plan Template',
    description: 'Legally compliant intervention planning document',
    lastUpdated: '2023-07-28'
  }
];

export const ComplianceDocuments: React.FC = () => {
  const handleDownload = (documentId: string) => {
    // Implement document download logic
    console.log('Downloading document:', documentId);
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Compliance Documents
      </Typography>

      <List>
        {mockDocuments.map((doc) => (
          <ListItem
            key={doc.id}
            sx={{
              bgcolor: 'background.paper',
              mb: 1,
              borderRadius: 1,
              flexDirection: 'column',
              alignItems: 'flex-start'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', mb: 1 }}>
              <ListItemIcon>
                <DocumentIcon />
              </ListItemIcon>
              <ListItemText
                primary={doc.name}
                secondary={`Last updated: ${doc.lastUpdated}`}
              />
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {doc.description}
            </Typography>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={() => handleDownload(doc.id)}
              size="small"
            >
              Download Template
            </Button>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};